import React, { useEffect, useState } from "react";
import { getUserDetails } from "../API/index";
// import Loader from "./Loader";
import Table from "./Table";
import { useNavigate } from "react-router-dom";
import ArrowLeft from "../assets/images/left-arrow.png";
import "../assets/styles/users.scss";

const UserList = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  // const [error, setError] = useState(false);
  const navigate = useNavigate();

  const getAllUsersData = async () => {
    try {
      const status = true;
      const data = await getUserDetails(status);
      if (data) {
        setList(data);
        setLoading(false);
      }
    } catch (error) {
      // setError(true);
      setLoading(false);
    }
  };
  const detailHandler = (id) => {
    navigate(`/user-details/${id}`, {
      state: {
        id: id,
      },
    });
  };
  useEffect(() => {
    getAllUsersData();
  }, []);
  let tableHeadings = ["Employee Id", "Name", "Labor Item", "Status",  "Action"];

  return (
    <div className="users-page project-details-page">
      <div className="options">
        <div className="project-details-toolbar users-list-header">
          <button
            className="btn btn-primary back-btn project-details-back-btn"
            onClick={() => navigate(-1)}
            type="button"
          >
            <img src={ArrowLeft} alt="Back" />
          </button>
          <h1 className="title project-details-title">Users</h1>
          <div className="project-details-toolbar__actions">
            <div className="search-container">
              <form className="form-wo" onSubmit={(event) => event.preventDefault()}>
                <button type="button" aria-label="Search users">
                  <svg
                    width="17"
                    height="16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                  >
                    <path
                      d="M7.667 12.667A5.333 5.333 0 107.667 2a5.333 5.333 0 000 10.667zM14.334 14l-2.9-2.9"
                      stroke="currentColor"
                      strokeWidth="1.333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </button>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(event) => setSearchQuery(event.target.value)}
                  style={{
                    border: "0",
                    background: "transparent",
                    fontSize: "13px",
                    width: "150px",
                    padding: "0.5rem 0",
                  }}
                />
                <button
                  className="reset"
                  type="reset"
                  onClick={() => setSearchQuery("")}
                  aria-label="Clear search"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </button>
              </form>
            </div>
          </div>

          {/* <div className="options">
            <SideDropDownOptions />
          </div> */}
        </div>
        {/* <h2 className="title">Users</h2>{" "}
          <div className="">
            <SideDropDownOptions />
          </div> */}
      </div>
      <div>
        {/* {loading && <Loader />}
          {error && <div>Something went wrong</div>}
          {!loading && !error && ( */}
        <Table
          tableHeadings={tableHeadings}
          list={list?.data}
          detailHandler={detailHandler}
          loading={loading}
          searchQuery={searchQuery}
        />
        {/* )} */}
      </div>
    </div>
  );
};

export default UserList;
